export default () => {
    const hamburger = document.querySelector('.hamburger'),
        header = document.querySelector('header'),
        body = document.querySelector('body');

    hamburger.addEventListener('click', (e) => {
        hamburger.classList.toggle('is-active');
        body.classList.toggle('oh');
        setTimeout(() => {
            header.classList.toggle('is-active');
        }, 250);
    });
}
